import { render, staticRenderFns } from "./TgLogo.vue?vue&type=template&id=da60c2d2"
import script from "./TgLogo.vue?vue&type=script&lang=js"
export * from "./TgLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports